import React from "react";

const ComponentTitle = ({title}) => {
  return (
    <>
      <div className=" mt-2 text-rgbaprimary9 font-poppins font-bold p-3 text-lg ">
        {title}
      </div>
    </>
  );
};

export default ComponentTitle;
